export default __webpack_public_path__ + "static/media/photoshop.5391f8ea.svg";